var map = {
	"./en-US": "TAoa",
	"./en-US.js": "TAoa",
	"./en-US/login": "m7Pj",
	"./en-US/login.js": "m7Pj",
	"./zh-CN": "/1lm",
	"./zh-CN.js": "/1lm",
	"./zh-CN/login": "58bc",
	"./zh-CN/login.js": "58bc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "t8oM";


//////////////////
// WEBPACK FOOTER
// ./src/locales/lang ^\.\/.*$
// module id = t8oM
// module chunks = 1